import { connect } from 'react-redux'
import { compose } from 'redux'
import { withCurrentRoute } from '../../components/HOCComponents/withCurrentRoute'
import { getUserName } from '../../selectors/users'
import { areRequestsPending } from '../../selectors/ui'

import { getIsPageReady } from '../../selectors/config'
import HeadTitle from '../../components/UIComponents/HeadTitle'

const mapStateToProps = (state, { currentLocation }) => ({
  userName: getUserName(state),
  isPageReady: getIsPageReady(state, currentLocation.isDashboard),
  isLoading: areRequestsPending(state)
})

export default compose(withCurrentRoute, connect(mapStateToProps))(HeadTitle)
